module.exports = __webpack_public_path__ + "img/69.2.TN.18e1d9ce.png";